import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { RECIPE_ATTRS } from './salesData';
import { RECIPES_IMAGE_URL } from '../utils/headMeta';
export function PositioningSection() {
  return <section id="recetas" className="bg-sand py-12 sm:py-16" data-id="element-193" data-mp="102arz83bahg1">
      <div className="mx-auto max-w-5xl px-5" data-id="element-194" data-mp="v512jsfxa5s7">
        <div className="text-center" data-id="element-195" data-mp="q67onywq4cri">
          <SectionTag className="bg-white" data-id="element-196" data-mp="q790i5lkd3aa">Cómo son las recetas</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[22ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.2rem]" data-id="element-197" data-mp="m4cleov8fpb3">
            Comida rica y abundante, sin harinas con gluten y baja en carbos.
          </h2>
        </div>

        <div className="mt-6 overflow-hidden rounded-3xl" data-id="element-198" data-mp="2bjk75ifeqnbj">
          <img src={RECIPES_IMAGE_URL} alt="Mesa con salmón, ensalada con palta y huevo, carne, panes sin TACC y sopa cremosa" loading="lazy" decoding="async" width={1400} height={787} className="h-[190px] w-full object-cover sm:h-[320px]" data-id="element-199" data-mp="2bj0zcujh1fb8" />
        </div>

        <div className="mt-2.5 grid grid-cols-2 gap-2 lg:grid-cols-3" data-id="element-200" data-mp="1vgvklmw2hyn3">
          {RECIPE_ATTRS.map((attr, i) => <motion.div key={attr.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 4) * 0.03
        }} className={attr.highlight ? 'col-span-2 rounded-xl border-2 border-gold bg-white px-3.5 py-3 shadow-[0_18px_40px_-30px_rgba(140,100,4,0.7)] lg:col-span-1' : 'rounded-xl border border-stone bg-white px-3.5 py-3'} data-id="element-201" data-mp="20ghxtwbwbevw" data-mpi={i}>
              {attr.highlight && <span className="mb-1.5 inline-flex items-center gap-1.5 rounded-full bg-gold px-2 py-0.5 font-display text-[0.54rem] font-bold uppercase tracking-[0.1em] text-charcoal" data-id="element-202" data-mp="3bwf1yrsb25dp">
                  <StarIcon className="h-2.5 w-2.5" aria-hidden strokeWidth={3} data-id="element-203" data-mp="3gpemzbk22tuo" />
                  Lo importante
                </span>}
              <h3 className={`font-display font-bold leading-tight tracking-tight ${attr.highlight ? 'text-[0.98rem] uppercase text-gold-deep' : 'text-[0.86rem] text-charcoal'}`} data-id="element-204" data-mp="37rky2lomf2hj">
                {attr.title}
              </h3>
              <p className="mt-0.5 font-sans text-[0.78rem] leading-snug text-taupe" data-id="element-205" data-mp="2t26iuwyd5qu8">{attr.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}